/** Non-secret, per-shop onboarding attribution. Storage is not authority for admission or connection. */
import * as z from 'zod'

const journeySchema = z.strictObject({ id: z.uuid(), returned: z.boolean() })
const memory = new Map<string, z.infer<typeof journeySchema>>()
let activeShop: string | undefined

/** Called before entry capture and by the existing connection request, so the first view and signed handoff agree. */
export function getShopifyJourney(shop: string, unconnected = false): string {
  const key = `testfeed:shopify-journey:${shop}`
  let stored = memory.get(shop)
  const alreadyLoaded = Boolean(stored)
  let arriving = false
  try {
    if (activeShop && activeShop !== shop) {
      globalThis.window?.sessionStorage.removeItem(`testfeed:shopify-journey:${activeShop}`)
      memory.clear()
      stored = undefined
    }
    if (!stored) {
      const raw = globalThis.window?.sessionStorage.getItem(key)
      if (raw) {
        const parsed = journeySchema.safeParse(JSON.parse(raw))
        if (parsed.success) stored = parsed.data
        else console.error('SHOPIFY_JOURNEY_STORAGE_INVALID')
      }
    }
    const browser = globalThis.window
    const queryId = z.uuid().safeParse(new URLSearchParams(browser?.location.search).get('journeyId'))
    if (queryId.success) {
      arriving = true
      stored = { id: queryId.data, returned: true }
      if (browser) {
        const url = new URL(browser.location.href)
        url.searchParams.delete('journeyId')
        browser.history.replaceState(browser.history.state, '', url)
      }
    }
  } catch {
    console.error('SHOPIFY_JOURNEY_STORAGE_UNAVAILABLE')
  }
  // A new unconnected launch after an arrival is a new attempt; refetches retain the same attempt.
  if (!stored || (unconnected && stored.returned && !alreadyLoaded && !arriving))
    stored = { id: crypto.randomUUID(), returned: false }
  activeShop = shop
  memory.set(shop, stored)
  try {
    globalThis.window?.sessionStorage.setItem(key, JSON.stringify(stored))
  } catch {
    console.error('SHOPIFY_JOURNEY_STORAGE_UNAVAILABLE')
  }
  return stored.id
}
